import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { deviceFromPet } from '../../helpers/dataHelpers.ts'
import { IPet } from '../../interfaces/types.ts'
import dataStore from '../../store/dataStore.ts'
import drawerStore from '../../store/drawerStore.ts'
import { Battery } from '../dashboard/components/Battery.tsx'
import './Dashboard2.css'
import { centerMapOnPet } from '../map/mapHelpers.tsx'
import { DateTime } from 'luxon'
import authStore from '../../store/authStore.ts'
import { DeviceControls } from './DeviceControls.tsx'
import { fenceIcon } from '../../helpers/colorHelper.ts'
import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon'
import { isSleepFeatureEnabled, hasScheduledSleep } from '../../helpers/sleepHelper.ts'
import { AlarmClockIcon } from '../svgs/AlarmClockIcon.tsx'

interface Props {
}

const createBooleanArray = (length: number, initialValue = false): boolean[] => {
    return Array.from({ length }, () => initialValue)
}

export const Dashboard2: React.FC<Props> = (props) => {
    const { } = props
    const devices = dataStore((s) => s.devices)
    const pets = dataStore(s => s.pets)
    const account = dataStore(s => s.account)
    // const navigate = useNavigate()
    const showPetList = drawerStore(s => s.petList)

    const [open, setOpen] = React.useState<boolean[]>(createBooleanArray(devices.length, false))
    const [more, setMore] = React.useState<boolean[]>(createBooleanArray(devices.length, false))

    const petsWithSorted = pets.filter((p: IPet) => deviceFromPet(p)).sort((a: IPet, b: IPet) => a.petName > b.petName ? 1 : -1)
    const sleepFeatureEnabled = isSleepFeatureEnabled(account)

    const petsWithDevices = petsWithSorted.map((pet: IPet, index: number) => {
        const d = deviceFromPet(pet)

        // const rate = readableSeconds(d?.status.backgroundInterval || 900).split(' ')
        const locationDate = d?.lastLocation?.properties?.receivedTime ? DateTime.fromISO(d.lastLocation.properties.receivedTime)
            .setZone(authStore.getState().timezone.value).toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY)
            : 'No locations received'
        const powerSavingMode = d?.status.beaconInRange && d?.status.powerOn
        const isCharging = d?.status.charging
        let findDisabled = !d?.status.powerOn || powerSavingMode
        findDisabled = isCharging ? false : findDisabled
        findDisabled = d?.status.deviceCommandInProgressStatus ? true : findDisabled
        const safeZoneName = d?.status.occupiedZone || 'Safe Zone'

        // const off = !d?.status.powerOn ?
        //     <div
        //         className={'rounded px-1 h-4 m-auto w-fit text-center bg-primary-content text-sm text-accent font-bold leading-[14px]'}>
        //         Gibi Off
        //     </div>
        //     : null

        const displayedDate = (
            <div className={'flex flex-col -mt-1'}>
                <div className={'text-primary-content text-md font-semibold text-nowrap'}>{locationDate}</div>
                {/* {off || inPowerSavingMode || staleWarning}*/}
            </div>
        )

        const topRow = (
            <div className={'flex-1'}>
                <div className={'flex items-center justify-between w-full'}>
                    <div className={'font-bold text-2xl text-left ml-9'}> {pet.petName}</div>
                </div>
            </div>
        )

        const petAvatar = (
            <div className={'rounded-full border border-2 border-white shrink-0'}>
                <div className={'rounded-full border border-4'} style={{ borderColor: pet.iconColor }}>
                    <div className={'rounded-full border border-2 border-white'}>
                        <img className={'rounded-full w-[60px] h-[60px] object-cover'} src={pet.imageURL} />
                    </div>
                </div>
            </div>
        )

        const safeZoneIndicator = (
            <div className={'flex flex-col gap-1 items-center self-start w-[60px] mr-2'}>
                <div
                    className={`font-semibold text-lg flex items-center justify-self-center rounded-full w-[40px] h-[40px] border-2 border-white ${!d?.status.safeZoneViolation ? 'bg-success' : 'bg-gray-400'}`}>
                    <img className={'w-9 mt-2 ml-[2px]'}
                        src={fenceIcon(!d?.status.safeZoneViolation ? '#ffffff' : '#fff')} />
                </div>
                <div
                    className={'overflow-hidden bg-transparent text-primary-content justify-self-center'}>
                    {safeZoneName}
                </div>
            </div>
        )

        const beaconIndicator = (
            <div className={'flex flex-col gap-1 items-center relative self-start w-[60px]'}>
                <div
                    className={`flex items-center justify-self-center rounded-full w-[40px] h-[40px] border-2 border-white ${powerSavingMode ? 'bg-success' : 'bg-gray-400'}`}>

                </div>
                <div
                    className={'bg-transparent text-primary-content justify-self-center'}>
                    Power Saving
                </div>
            </div>
        )

        const batteryIndicator = (
            <div className={'self-start w-[60px] flex justify-center'}>
                <Battery pet={pet} iconOnly />
            </div>
        )

        const showSleepIndicator = sleepFeatureEnabled
        // const sleepWakeReason = getWakeReasonText(d?.status.wakeReason)
        const isSleeping = d?.status.sleeping === true
        const isScheduled = d?.status ? hasScheduledSleep(d.status) : false

        // Three states: sleeping (green bg + moon), scheduled (white bg + green clock), idle (gray bg + moon)
        const sleepBg = isSleeping ? 'bg-success' : isScheduled ? 'bg-white' : 'bg-gray-400'

        const sleepIndicator = showSleepIndicator ? (
            <div className={'flex flex-col gap-1 items-center self-start w-[60px]'}>
                <div
                    className={`flex items-center justify-center rounded-full w-[40px] h-[40px] border-2 border-white ${sleepBg}`}>
                    {isScheduled && !isSleeping
                        ? <AlarmClockIcon color="hsl(var(--su))" size={22} />
                        : <FontAwesomeIcon icon={faMoon} className={'text-white text-xl'} />
                    }
                </div>
                <div className={'bg-transparent text-primary-content justify-self-center'}>
                    {isSleeping ? 'Sleeping' : isScheduled ? 'Sleep Scheduled' : 'Sleep'}
                </div>
                {/* {sleepWakeReason && (
                    <div className={'text-xs text-primary-content text-center max-w-[60px] leading-tight'}>
                        {sleepWakeReason}
                    </div>
                )} */}
            </div>
        ) : null

        return (
            <div key={d?._id} id={d?._id} className={`flex items-start show popup `}>
                <div onClick={() => centerMapOnPet(pet)}>
                    <div
                        className={'flex flex-col p-2 w-[27rem] gap-0 bg-primary text-primary-content rounded-xl ml-2 h-[168px]'}>

                        {topRow}

                        <div className={'flex items-center justify-between w-[95%] h-[90px]'}>
                            {petAvatar}
                            <div className={'flex gap-3 items-center justify-evenly pt-6'}>
                                {safeZoneIndicator}
                                {beaconIndicator}
                                {sleepIndicator}
                                {batteryIndicator}
                            </div>
                        </div>
                        <div id={'spacer flex-1'} className={'w-full h-4'} />

                        {/*{displayedDate}*/}

                        <button id={'control-button'} type="button"
                            className={`collapsible p-0 bg-base-300`}
                            onClick={(e) => {
                                e.stopPropagation()
                                const update = open.slice(0)
                                update[index] = !update[index]
                                if (!update[index]) {
                                    const u = more.slice(0)
                                    u[index] = false
                                    setMore(u)
                                }
                                setOpen(update)
                            }}
                        >
                            <div className="py-0 flex items-center justify-between gap-4">
                                <div className={'text-md text-nowrap ml-2'}>{d?.deviceName}</div>
                                {displayedDate}
                                <div className={'w-8'}>
                                    {open[index] ? <FontAwesomeIcon icon={faChevronLeft} className={'ml-2'} /> :
                                        <FontAwesomeIcon icon={faChevronRight} className={'ml-2'} />
                                    }
                                </div>
                            </div>
                        </button>

                    </div>
                </div>
                {open[index] ?
                    <DeviceControls pet={pet} show={true} disabled={Boolean(findDisabled)} />
                    : null}
            </div>
        )
    })

    return showPetList ? (
        <div className={'min-w-[260px] flex flex-col items-start gap-2 overflow-x-auto max-h-[75vh] transparentScroll'}>
            {petsWithDevices}
        </div>
    ) : null
}
